function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 36H12.15V41.835H3V36Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.4799 36.681L18.564 19.377L22.1129 20.625L16.0319 37.929L12.4799 36.681Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.78501 9.65099L6.32701 14.643C6.32701 14.643 5.44501 16.965 7.60801 17.685C10.044 18.429 28.584 23.937 28.584 23.937L32.757 16.797L7.78501 9.65099V9.65099Z",
  fill: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M41.1271 14.913C41.4421 14.796 47.8741 11.313 47.8741 11.313C47.3881 10.824 47.1031 10.455 46.3891 10.248L12.4351 0.303007C11.9081 0.144742 11.3552 0.0919265 10.8078 0.147583C10.2605 0.20324 9.72947 0.366276 9.24519 0.627364C8.76091 0.888451 8.33286 1.24247 7.98554 1.66915C7.63822 2.09584 7.37844 2.58682 7.22106 3.11401L6.16806 6.70501C6.16806 6.70501 35.2921 15.237 36.1861 15.363L33.1291 20.757L41.9671 23.832L44.9371 15.066C44.9371 15.063 41.6071 15.063 41.1271 14.913Z",
  fill: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.27703 36.537L4.20903 34.95C10.041 31.356 12.039 21.762 11.979 14.637L13.953 14.619C14.016 22.587 11.775 32.532 5.27703 36.537Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.087 38.988C6.087 43.923 3.363 47.919 0 47.919V30.063C3.363 30.063 6.087 34.059 6.087 38.988Z",
  fill: "black"
});

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.1d1eb856.svg";
export { ForwardRef as ReactComponent };